<template>
  <div>
    <v-card tile flat outlined class="bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5">
            <base-breadcrumbs v-if="['bcmp', 'luring'].includes(jenis)" class="pa-0" :items="breadcrumbs[jenis]" />
            <h1 class="headline black--text">
              {{
                isDaring
                  ? 'Diklat Daring'
                  : jenis === 'bcmp'
                  ? 'Daftar Bimtek BCMP'
                  : jenis === 'refreshment'
                  ? 'Bimtek PPM & PPTM'
                  : 'Diklat Luring'
              }}
            </h1>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header
          @search="onSearch"
          :btnFilter="false"
          :btnAdd="$allow(`${akses}.create`)"
          @add="onAddDiklat"
          @reload="onReload"
          @filter="onFilter"
        >
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text">
              <b>{{ total }}</b> Diklat
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterStatus"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col class="py-0" cols="12" md="4">
                      <v-list-item class="px-0 py-1" @click="onDetailDiklat(item)">
                        <v-list-item-avatar color="primary">
                          <v-icon dark>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 mt-3">
                          <div class="label--text">Nama Diklat</div>
                          <div class="body-1 black--text">
                            <strong>{{ $getDeepObj(item, 'nama') || '-' }}</strong>
                          </div>
                          <div v-if="jenis === 'bcmp'" class="grey--text mb-1">
                            <i>Angkatan {{ $getDeepObj(item, 'angkatan') }}</i>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <template v-if="jenis === 'bcmp'">
                      <v-col class="py-0" cols="12" md="3">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <div class="label--text">Tanggal Mulai</div>
                            <div class="body-2">
                              {{ $formatMoment($getDeepObj(item, 'tgl_mulai'), 'DD MMMM YYYY') }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" md="3">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <div class="label--text">Tanggal Selesai</div>
                            <div class="body-2">
                              {{ $formatMoment($getDeepObj(item, 'tgl_selesai'), 'DD MMMM YYYY') }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col v-if="isDaring" class="py-0" cols="12" md="3">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <div class="label--text">{{ isDaring ? 'Tahapan Diklat' : 'Angkatan' }}</div>
                            <div class="body-2">
                              <template v-if="isDaring">
                                {{ $getDeepObj(item, 'paud_periode.data.nama') || '-' }}
                              </template>
                              <template v-else> Angkatan {{ $getDeepObj(item, 'angkatan') || '-' }} </template>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" :md="isDaring ? 2 : 3">
                        <v-list-item class="px-0">
                          <v-list-item-content>
                            <template v-if="jenis !== 'refreshment'">
                              <span class="caption">Jenis Diklat</span>
                              <div>
                                {{
                                  $getDeepObj(
                                    M_DIKLAT,
                                    `${item[jenis === 'refreshment' ? 'k_diklat_bimtek_paud' : 'k_diklat_paud']}`
                                  )
                                }}
                              </div>
                            </template>
                            <div v-if="item.k_jenjang_diklat_paud">
                              <span class="caption">Jenjang Diklat</span>
                              <div>
                                {{ $getDeepObj(masters, `m_jenjang_diklat_paud.${item.k_jenjang_diklat_paud}`) }}
                              </div>
                            </div>
                            <div v-if="item.k_moda_paud">
                              <span class="caption">Moda Bimtek</span>
                              <div>
                                {{ $getDeepObj(item, `m_moda_paud.data.keterangan`) }}
                              </div>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col class="py-0" cols="12" md="3">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0 mt-3">
                            <span class="caption">{{ isDaring ? 'Tanggal Pendaftaran' : 'Tanggal Pelaksanaan' }}</span>
                            <p>
                              <span v-if="isDaring">
                                {{
                                  $durasi(
                                    $getDeepObj(item, 'paud_periode.data.tgl_daftar_mulai'),
                                    $getDeepObj(item, 'paud_periode.data.tgl_daftar_selesai')
                                  )
                                }}
                              </span>
                              <span v-else>
                                {{ $durasi($getDeepObj(item, 'tgl_mulai'), $getDeepObj(item, 'tgl_selesai')) }}
                              </span>
                            </p>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </template>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="mapActions(item)" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      colorBtn="primary"
      generalError
      :title="formulir.title"
      :useSave="formulir.useSave"
      @save="onSave"
    >
      <component
        ref="formulir"
        :is="formulir.form"
        :masters="masters"
        :type="formulir.type"
        :periodes="periodes"
        :initValue="formulir.init"
        :jenis="jenis"
      ></component>
    </base-modal-full>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs';
import FormDiklat from '../../formulir/FormDiklat';
import DetailBimtek from '../diklat/Detail.vue';
import DetilKelas from '../../formulir/Detail';
import mixin from '../base/mixin';
import list from '@mixins/list';
export default {
  mixins: [list, mixin],
  components: { FormDiklat, DetilKelas, BaseBreadcrumbs, DetailBimtek },
  props: {
    jenis: {
      type: String,
      default: 'daring',
    },
    actions: {
      type: Array,
      default: () => [],
    },
    akses: {
      type: String,
      default: 'lpd-diklat',
    },
  },
  data() {
    return {
      formulir: {},
      akun: {},
      groups: {},
      periodes: [],
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    M_DIKLAT() {
      if (this.jenis === 'refreshment') {
        return (this.masters && this.masters.m_diklat_bimtek_paud) || {};
      } else {
        return {
          1: 'Diklat Berjenjang',
          2: 'Diklat BCP',
          3: 'Diklat MOT',
          4: 'Diklat Lainnya',
        };
      }
    },

    breadcrumbs() {
      return {
        luring: [{ text: 'Diklat Luring Tersistem', to: `kelola-diklat-luring` }, { text: 'Kelola Diklat Luring' }],
        bcmp: [{ text: 'Bimtek BCMP', to: `kelola-diklat-bcmp` }, { text: 'Kelola Bimtek BCMP' }],
        refreshment: [
          { text: 'Bimtek Refreshment', to: `kelola-diklat-refreshemnt` },
          { text: 'Kelola Bimtek Refreshment' },
        ],
      };
    },

    configs() {
      const M_PROPINSI = this.masters.m_propinsi || {};
      const M_KOTA = this.masters.m_kota || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 12 }, { cols: 12 }],
        disabled: [],
      };
    },

    formFilter() {
      return [
        {
          label: 'Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
      ];
    },

    filtersMaster() {
      return {
        k_propinsi: this.masters && this.masters.m_propinsi,
        k_kota: this.masters && this.masters.m_kota,
      };
    },

    isDaring() {
      return this.jenis === 'daring';
    },
  },
  created() {
    Object.assign(this.attr, { jenis: this.jenis });

    this.getMasters({
      name: [
        'm_propinsi',
        'm_kota',
        'm_diklat_paud',
        'm_diklat_bimtek_paud',
        'm_jenjang_diklat_paud',
        'm_moda_paud',
        'm_kategori_bimtek_paud',
      ].join(';'),
      filter: {
        0: {
          k_propinsi: {
            op: '<',
            val: 90,
          },
        },
      },
    });

    if (['daring', 'luring'].includes(this.jenis)) this.listPeriodes();
  },
  methods: {
    ...mapActions('diklat', [
      'fetch',
      'create',
      'update',
      'listGroups',
      'getPeriode',
      'action',
      'lookup',
      'getDetail',
      'downloadList',
    ]),

    allow(action, data) {
      let disabled = false;
      switch (action.event) {
        case 'onAktif':
          disabled = !Number(this.$getDeepObj(data, 'akun.is_aktif') || 0);
          break;
        case 'onNonAktif':
          disabled = Number(this.$getDeepObj(data, 'akun.is_aktif') || 0);
          break;
        default:
          disabled = this.$allow(action.akses, data.policies);
          break;
      }
      return disabled;
    },

    mapActions(item) {
      let action = [];

      this.actions.forEach((obj) => {
        let status = { ...obj };
        if (Number(item.is_readonly) === 1 && ['onDeleteDiklat'].includes(obj.event)) {
          status.readonly = true;
          status.tooltip = this.jenis === 'bcmp' ? 'Diklat sudah memiliki kelas' : 'Kelas dalam proses verval';
        }
        action.push(status);
      });

      return action;
    },

    onShowBimtek(item) {
      this.getDetail({ id: item.id, jenis: this.jenis }).then(({ data }) => {
        this.$set(this.formulir, 'form', 'detail-bimtek');
        this.$set(this.formulir, 'type', 'diklat');
        this.$set(this.formulir, 'isEdit', false);
        this.$set(this.formulir, 'id', item.id);
        this.$set(this.formulir, 'useSave', false);
        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$set(this.formulir, 'title', `Detail ${this.jenis === 'refreshment' ? 'Bimtek' : 'Diklat'}`);
          this.$set(this.formulir, 'init', Object.assign({}, data));
        });
      });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #ffab91;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
